import { ACTIONS } from "./actions";




const initialState = {
  report_data: null,
  report_loader: true,

  qoeSummary: null,
  qoeSummary_loader: true,

  qoe_chart_data: null,
  qoe_chart_loader: true,

  tunnel_table_loader: true,
  tunnel_data: [],

  top_users_table: [],
  top_users_loader: true,

  siteList: [],
  siteList_loader: true,

  mapSites: [],
  map_loader: true,

  siteSummary: [],
  siteSummary_loader: true,
  customList: [],
  customListError: null,
  mapSitesError: null,
  siteList_error: null,
  tunnel_table_error: null,
  top_users_error: null
};

const reducer = (state = initialState, action) => {
  const { type, payload, error } = action;

  if (error) {
    // @TODO : Handle errors
  }

  switch (type) {
    case ACTIONS.SET_REPORT_LOADING:
      return {
        ...state,
        report_loader: true
      };
    case ACTIONS.SET_REPORT_DATA:
      return {
        ...state,
        report_data: payload,
        report_loader: false
      };
    case ACTIONS.SET_QOESUMMARY_LOADING:
      return {
        ...state,
        qoeSummary_loader: true
      };
    case ACTIONS.SET_QOESUMMARY:
      return {
        ...state,
        qoeSummary: payload,
        qoeSummary_loader: false
      };
    case ACTIONS.SET_QOECHART_LOADING:
      return {
        ...state,
        qoe_chart_loader: true
      };
    case ACTIONS.SET_QOECHART:
      return {
        ...state,
        qoe_chart_data: payload,
        qoe_chart_loader: false
      };
    case ACTIONS.SET_TUNNEL_TABLE:
      return {
        ...state,
        tunnel_data: payload,
        tunnel_table_loader: false
      };
    case ACTIONS.TUNNEL_TABLE_LOADING:
      return {
        ...state,
        tunnel_table_loader: true
      };
    case ACTIONS.SET_TOPUSERS_TABLE:
      return {
        ...state,
        top_users_table: payload,
        top_users_loader: false
      };
    case ACTIONS.TOPUSERS_TABLE_LOADING:
      return {
        ...state,
        top_users_loader: true
      };
    case ACTIONS.SITE_LIST_LOADING:
      return {
        ...state,
        siteList_loader: true
      };
    case ACTIONS.MAP_LOADING:
      return {
        ...state,
        map_loader: true
      };
    case ACTIONS.MAP_SITES:
      return {
        ...state,
        mapSites: payload,
        map_loader: false
      };

    case ACTIONS.SITE_SUMMARY_LOADING:
      return {
        ...state,
        siteSummary_loader: true
      };

    case ACTIONS.SITE_SUMMARY:
      return {
        ...state,
        siteSummary: payload,
        siteSummary_loader: false
      };
    case ACTIONS.SET_ERROR:
      return {
        ...state,
        ...payload
      };
    case ACTIONS.SET_CUSTOM_LIST:
      return {
        ...state,
        customList: payload,
        siteSummary_loader: false
      };

    default:
      return state;
  }
};

export default reducer;
